import { type PropsWithChildren, useMemo } from "react";
import { useListingQuery } from "../api/hooks";
import { DynamicDateFormatter } from "../utils/dynamic-date-formatter";
import { FALLBACK_LOCALE, FormattersContext } from "./formatters";

export function FormattersProvider({ children }: PropsWithChildren) {
  const { data: listing } = useListingQuery();
  const locale = listing?.locale ?? FALLBACK_LOCALE;
  const value = useMemo(
    () => ({ locale, dateFormatter: new DynamicDateFormatter(locale) }),
    [locale],
  );

  return (
    <FormattersContext.Provider value={value}>
      {children}
    </FormattersContext.Provider>
  );
}
